import React, {useContext, useState} from "react";
import { Box, TextField, Button, Divider } from '@mui/material';
import { ResponsiveChartContainer, AreaPlot, ChartsTooltip, MarkPlot, LinePlot, LineHighlightPlot } from '@mui/x-charts';

/**
 * @author Sarthak Sharma.
 * @since 27-12-2023.
 * @description Toat Report component.
 */

const TotalCounter = (props): React.ReactElement => {
    const {
        title,
        counts,
        bottomLeftComponent,
        linkText,
        onClickLink,
        graphData
    } = props;

    return (
        <Box className="flex count-card flex-col gap-3 p-5 w-full">
            <div>
                <div className="text-zinc-500 text-sm font-['Poppins-Regular'] leading-[30px]">{title}</div>
            </div>
            <div className="flex justify-between items-center h-[63px]">
                <div className="text-neutral-800 text-[28px] font-['Poppins-Regular'] leading-[30px]">{counts}</div>
                {graphData && (
                    <div className="w-[100px]">
                        <ResponsiveChartContainer
                            margin={{ top: 5, left: 5, right: 5, bottom: 5 }}
                            height={63}
                            series={[
                                {
                                    data: graphData,
                                    type: 'line',
                                    color: `#a1a0ea`,
                                    area: true,
                                },
                            ]}
                            xAxis={[{ scaleType: 'point', data: ["A", "B", "C", "D", "E", "F"]}]}
                            sx={{
                                '& .MuiAreaElement-root': {
                                    fill: "#a1a0ea45",
                                }
                            }}
                        >
                            <AreaPlot />
                            <ChartsTooltip  />
                            <LinePlot />
                            <LineHighlightPlot />
                        </ResponsiveChartContainer>
                    </div>
                )}
            </div>
            {/* <Divider />
            <div className="flex justify-between items-center">
                {bottomLeftComponent}
                <div onClick={onClickLink} className="text-blue-600 text-sm font-['Poppins-Regular'] leading-[30px] active:underline select-none cursor-pointer">
                    {linkText}
                </div>
            </div> */}
        </Box>
    );
}

export default React.memo(TotalCounter, (prevProps, nextProps) => {
    return (
        prevProps.title === nextProps.title &&
        prevProps.linkText === nextProps.linkText &&
        prevProps.graphData === nextProps.graphData &&
        prevProps.counts === nextProps.counts
    );
});

// export default TotalCounter;